import { render, staticRenderFns } from "./SfTopBar.vue?vue&type=template&id=2772494f"
import script from "./SfTopBar.vue?vue&type=script&lang=js"
export * from "./SfTopBar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfTopBar.vue?vue&type=style&index=0&id=2772494f&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "104defc6"
  
)

export default component.exports